import { gridKey, buttonKey } from '../../Form/FormRules';
import { t } from '@lingui/core/macro';

function DefaultAddMoreButton(onClick) {
    return [
        {
            type: gridKey,
            fields: [
                {
                    type: buttonKey,
                    icon: {
                        name: 'plus',
                        position: 'left',
                    },
                    title: t({ message: 'Add more', context: 'DefaultAddMoreButton' }),
                    onClick: function () {
                        onClick && onClick();
                    },
                },
            ],
        },
    ];
}
export default DefaultAddMoreButton;
